module.exports = __webpack_public_path__ + "img/chess_chessblack2.558d9591.png";